import {
  ref,
} from "vue";

export const uiDynamischeFormDefinitionErrorLabels = ref({});

export function setErrorLabel({ id, label }) {
  uiDynamischeFormDefinitionErrorLabels.value[id] = label;
}
